import React from "react";
import EN from "../../../../config/translations/en";
import useI18n from "../../../lib/hooks/useI18n";
import { TreeChild } from "../../../types";
import styles from "./index.module.css";

interface Props {
  path: string;
  text: keyof typeof EN;
  handleTileClick: (event: any, child: TreeChild) => void;
  treeChild?: TreeChild;
}

const Tile = ({ path, text, treeChild, handleTileClick }: Props) => {
  const { i18n } = useI18n();

  return (
    <div
      onClick={(event) => handleTileClick(event, treeChild as TreeChild)}
      className={styles["tile"]}
    >
      <div className={styles["img-container"]}>
        <img className={styles["image"]} src={path} alt="TileImage" />
      </div>
      <div className={styles["text-container"]}>
        <p className={styles["text"]}>{i18n[text]}</p>
      </div>
    </div>
  );
};

export default Tile;
